import { TableCellType } from "@/constants/table/table"
import { WorkflowsHistoryTableRow } from "@/types/workflowHistory"
import { ColumnDef } from "@tanstack/react-table"

export const workflowsColumns: ColumnDef<WorkflowsHistoryTableRow>[] = [
  {
    accessorKey: "icons",
    header: "",
    meta: { type: TableCellType.ICONS, className: "p-0 py-2 px-4 w-44 flex flex-row items-center" },
  },
  {
    accessorKey: "nickname",
    header: "Nickname",
    meta: { type: TableCellType.LINK_BUTTON, className: "w-screen" },
  },
  {
    accessorKey: "dateCreated",
    header: "Date Created",
    meta: { type: TableCellType.DATE },
  },
  {
    accessorKey: "lastRunDate",
    header: "Last Run",
    meta: { type: TableCellType.DATE },
  },
  {
    accessorKey: "workflowExecutionCount",
    header: "Total Runs",
    meta: { type: TableCellType.TEXT },
  }
]
